/* raw layout hash: _default-web-layout:4002ada5bd906c1cb3868cf9bff6ddecb11ab92d1cd701d768cd8efccbcdfa4e */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout" — renders its page content through the router outlet.
export default function DefaultWebLayout() {
  return <AppShell layoutName="_default-web-layout" menu={LAYOUT_MENUS['_default-web-layout']} />;
}
